module.exports = __webpack_public_path__ + "img/class1.601745d5.png";